// extracted by css-extract-rspack-plugin
export default {"overlay":"OverlayPanel-module__overlay___mKroN","button":"OverlayPanel-module__button___F8kUw"};